"use strict";

exports.__esModule = true;
var _RequiredLabel = require("./RequiredLabel");
Object.keys(_RequiredLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RequiredLabel[key]) return;
  exports[key] = _RequiredLabel[key];
});